<template>
    <v-card :loading="loading" width="450">
        <v-card-title>
            <TitleOfDialog title="Add Mission" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
            <v-card-subtitle class="text-wrap mb-3">You are adding a mission to this vehicle.
            </v-card-subtitle>
            <v-form ref="missionForm">
                <v-select color="primary" label="Mission" :rules="[v => !!v || 'Mission is required']"
                    v-model="missionToAdd" required :items="possibleMissions" item-value="id" item-title="name">
                </v-select>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="validate()" class="w-100" color="primary" variant="elevated" text="Add mission"></v-btn>
        </v-card-actions>
    </v-card>

</template>


<script setup>
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useMissionStore } from '@/store/missionStore';

const missionStore = useMissionStore();
const { possibleMissions } = storeToRefs(missionStore);
const loading = ref(false);
const emit = defineEmits(['close'])
const props = defineProps(['vehicle']);
const missionForm = ref();
const missionToAdd = ref();

onMounted(() => {
    loading.value = true;
    missionStore.fetchPossibleMissions(props.vehicle.id);
    loading.value = false;
})


const validate = async () => {
    const isValid = await missionForm.value?.validate();
    if (isValid.valid) {
        loading.value = true;
        try {
            await missionStore.assingMission(missionToAdd.value, props.vehicle.id);
            loading.value = false;
            emit('close');
        } catch (error) {
            loading.value = false;
            console.error("Error en la validación o creación de la mision:", error);
        }
    } else {
        console.log("Formulario no válido:", isValid);
    }
}
</script>